module.exports = "/images/logout.svg?12f6f930f7e4ca847d5c3970aadc568e";